import {JWspDefProps, JWspTypeInst, WSP, Wsp} from "/@lib@/wsp/wsp.js";
import {EDrvState, JSrcIdent, SRC} from "/@lib@/wsp/src.js";
import {IO} from "/@lib@/commons/io/io.js";


interface OWspDrvCreateParams {
	drvAxis: string;
	alias?: string;
	desc?: string;
	drvDefaultSrcFindPath?: string;
}


export namespace WSP_DRV {

	export function getDrvStateLabel(st: EDrvState, l10nCtx=false): string {
		switch (st) {
		case "notComputed":
		case "createdNotComputed":
			return "";

		case "notOverriden":
			return l10nCtx ? "Non traduit, non achevé" : "Non surchargé, non achevé";
		case "notOverridenDone":
			return l10nCtx ? "Non traduit, marqué 'achevé'" : "Non surchargé, marqué 'achevé'";
		case "notOverridenDirty":
			return l10nCtx ? "Non traduit, à contrôler" : "Non surchargé, à contrôler";

		case "overridenNew":
			return l10nCtx ? "Traduit, non 'achevé'" : "Surchargé, non 'achevé'";
		case "overridenDone":
			return l10nCtx ? "Traduit, marqué 'achevé'" : "Surchargé, marqué 'achevé'";
		case "overridenDirty":
			return l10nCtx ? "Traduit, à contrôler" : "Surchargé, à contrôler";

		case "createdNew":
			return "Local, non 'achevé'";
		case "createdDone":
			return "Local, marqué 'achevé'";
		case "createdDirty":
			return "Local, à contrôler";

		case "erased":
			return "Supprimé";
		}
		return st;
	}

	export function getDrvStateDone(st: EDrvState): string {
		switch (st) {

		case "notOverriden":
		case "overridenNew":
		case "createdNew":
			return "Non 'achevé'";
		case "notOverridenDone":
		case "overridenDone":
		case "createdDone":
			return "Marqué 'achevé'";
		case "notOverridenDirty":
		case "overridenDirty":
		case "createdDirty":
			return "À contrôler";
		case "erased":
		case "notComputed":
		case "createdNotComputed":
			return "";

		}
		return st;
	}

	export function getDrvStateLayer(st: EDrvState, l10nCtx=false): string {
		switch (st) {
		case "notOverriden":
		case "notOverridenDone":
		case "notOverridenDirty":
			return l10nCtx ? "Non traduit" : "Non surchargé";
		case "overridenNew":
		case "overridenDone":
		case "overridenDirty":
			return l10nCtx ? "Traduit" : "Surchargé";
		case "createdNew":
		case "createdDone":
		case "createdDirty":
		case "createdNotComputed":
			return "Local";
		case "erased":
			return "Supprimé";
		case "notComputed":
			return "";
		}
		return st;
	}

	export function isDrv(props: JWspDefProps): boolean | undefined {
		if (!props) return undefined;
		return props.drvAxis ? true : false;
	}

	export async function createWspDrv(wspMaster: Wsp, params: OWspDrvCreateParams, wspType?: JWspTypeInst): Promise<Wsp> {
		(params as any).wspMaster = wspMaster.code;
		if (wspType == null) {
			if (!wspMaster.isLoaded) await wspMaster.waitForLoad();
			wspType = wspMaster.wspType;
		}
		return WSP.createWsp(wspMaster.wspServer, params, wspType);
	}

	export async function deleteDrvOverride(wsp: Wsp, srcUris: string | string[]): Promise<void> {
		const formData = new FormData();
		formData.append("refUris", Array.isArray(srcUris) ? srcUris.join('\t') : srcUris);
		return wsp.wspServer.config.drvUrl.fetchVoid("?cdaction=DeleteDrvOverride&param=" + wsp.code, {method: "POST", body: formData});
	}


	export async function srcDeleteOverride(wsp: Wsp, uiContext: HTMLElement, itemIdents: JSrcIdent[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		const fd = new FormData();
		fd.append("refUris", itemIdents.map(SRC.srcRef).join('\t'));
		return wsp.wspServer.config.drvUrl.fetchVoid(IO.qs("cdaction", "DeleteDrvOverride", "param", wsp.code), {method: "POST", body: fd});
	}

	export async function srcMarkDrvDone(wsp: Wsp, uiContext: HTMLElement, itemIdents: JSrcIdent[]): Promise<void> {
		if (!wsp.isAvailable) await wsp.waitForAvailable(uiContext);
		await wsp.wspServer.wspsLive.saveItems(wsp.code, itemIdents);
		const fd = new FormData();
		fd.append("refUris", itemIdents.map(SRC.srcRef).join('\t'));
		return wsp.wspServer.config.drvUrl.fetchVoid(IO.qs("cdaction", "MarkOverrideDone", "param", wsp.code), {method: "POST", body: fd});
	}

	/**
	 * Fournit les codes d'ateliers associés à chaque axis impliqués dans le chemin de résolution
	 * des contenus par défaut de cet ateler dérivé.
	 */
	export async function getFindPathWspCodeList(wspDrv: Wsp, uiContext: HTMLElement): Promise<{ [drvAxis: string]: string }> {
		if (!wspDrv.isAvailable) await wspDrv.waitForAvailable(uiContext);
		return wspDrv.wspServer.config.drvUrl.fetchJson<{ [drvAxis: string]: string }>(IO.qs("cdaction", "GetFindPathWspCodeList", "param", wspDrv.code));
	}

}
